export const REVENUECAT_PROJECT_ID_PREFIX = 'proj';
export const REVENUECAT_PROFILE_URL_PREFIX = 'https://app.revenuecat.com/customers/';